import { DEFAULT_CONTEXT } from '../../store/modules/errorBoundary'
import Error from './../Error'
import React from 'react'

export default ({
  context = DEFAULT_CONTEXT,
  errors,
  children,
}) =>
  errors[context] ? <Error critical={ true } /> : children
